import React from "react";
import "../../App.css";
import AboutUs from "../AboutUs/AboutUs";
import Footer from "../Footer";

export default function Products() {
  return (
    <>
      <AboutUs />
      <Footer />
    </>
  );
}
